/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Strength_Missing_WeightInputs */

const en_us2_exercise_personal_strength_missing_weight = /** @type {(inputs: Exercise_Personal_Strength_Missing_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`your weight`)
};

const pt_br2_exercise_personal_strength_missing_weight = /** @type {(inputs: Exercise_Personal_Strength_Missing_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`seu peso`)
};

const es_419_exercise_personal_strength_missing_weight = /** @type {(inputs: Exercise_Personal_Strength_Missing_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tu peso`)
};

const pt_pt2_exercise_personal_strength_missing_weight = /** @type {(inputs: Exercise_Personal_Strength_Missing_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`o teu peso`)
};

const fr_fr2_exercise_personal_strength_missing_weight = /** @type {(inputs: Exercise_Personal_Strength_Missing_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ton poids`)
};

const de_de2_exercise_personal_strength_missing_weight = /** @type {(inputs: Exercise_Personal_Strength_Missing_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dein Gewicht`)
};

const it_it2_exercise_personal_strength_missing_weight = /** @type {(inputs: Exercise_Personal_Strength_Missing_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`il tuo peso`)
};

/**
* | output |
* | --- |
* | "your weight" |
*
* @param {Exercise_Personal_Strength_Missing_WeightInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_strength_missing_weight = /** @type {((inputs?: Exercise_Personal_Strength_Missing_WeightInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Strength_Missing_WeightInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_strength_missing_weight(inputs)
	if (locale === "es-419") return es_419_exercise_personal_strength_missing_weight(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_strength_missing_weight(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_strength_missing_weight(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_strength_missing_weight(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_strength_missing_weight(inputs)
	return en_us2_exercise_personal_strength_missing_weight(inputs)
});
export { exercise_personal_strength_missing_weight as "exercise-personal.strength_missing_weight" }